import React from 'react';
import './index.css';

import {
  BenefitDto,
  CategoryCoverageDto,
} from 'enrollment/queries/useBenefitCategoryQuery/types';
import { CategoryHeader } from '../Categoryheader';
import { Plan } from '../Plan';
import { getPremiumDisplay } from 'enrollment/features/Benefits/BenefitsPreview/GroupedBenefits/utils';

interface CategoryData {
  category: string;
  coverages: BenefitDto[] | undefined;
  contextLookup: string;
}

export const BenefitCategory: React.FC<CategoryData> = (props) => {
  const totalCost =
    props.coverages?.reduce((acc, cov) => {
      let planCost = parseFloat(cov.coverage?.req_subscriber_premium || '0'); // Ensure we have a number, defaulting to 0 if not available
      cov.coverage?.rider_coverages.forEach((rider) => {
        // add rider values
        planCost += Number(rider.req_subscriber_premium);
      });
      cov.coverage?.coverage_lines?.forEach((covLine) => {
        covLine.rider_coverage_lines.forEach((riderLine) => {
          planCost += Number(riderLine.req_subscriber_premium);
        });
      });
      return acc + planCost;
    }, 0) || 0; // Default to 0 if coverages is undefined

  const isNonDeclinedTermination = (coverage: CategoryCoverageDto) => {
    if (!coverage) {
      return false;
    }
    const startDate = new Date(coverage.change_effective_date || '');
    const terminationDate = new Date(coverage.termination_date || '');

    if (!terminationDate || !startDate) {
      return false;
    }
    if (coverage.req_coverage_level_lookup_code === 'decline') {
      return false;
    }
    if (terminationDate <= new Date() || startDate >= terminationDate) {
      return true;
    }

    return false;
  };

  if (props.coverages && props.coverages?.length > 0) {
    return (
      <div className="card">
        <CategoryHeader category={props.category} cost={totalCost} />
        {props.coverages?.map((cov) => (
          <Plan
            key={cov.benefit.org_benefit_name}
            planName={
              cov.coverage?.req_coverage_level_lookup_code?.toLowerCase() ===
              'decline'
                ? cov.benefit.org_benefit_name
                : cov.coverage?.req_org_plan_name ||
                  cov.benefit.org_benefit_name
            }
            inEligible={isNonDeclinedTermination(
              cov.coverage as CategoryCoverageDto
            )}
            cost={cov.coverage ? `${getPremiumDisplay(cov.coverage)}` : ''}
            subscriberCost={cov.coverage?.subscriber_premium || ''}
            declined={
              cov.coverage?.req_coverage_level_lookup_code === 'decline'
                ? true
                : false
            }
            planId={String(cov.coverage?.req_org_plan_id)}
            coverageAmt={cov.coverage?.req_volume}
            guaranteedAmount={cov.coverage?.volume}
            provider={String(cov.coverage?.req_carrier_name)}
            coveredIndividuals={cov.coverage?.req_dependents}
            isDependentOnlyPlan={cov.coverage?.is_dependent_only_plan || false}
            contextLookup={props.contextLookup}
            benefitData={cov}
            orgBenefitId={cov.benefit.org_benefit_id}
            benefitCategory={cov.benefit.org_benefit_category}
            benefitClass={cov.benefit.benefit_class}
            waitingForEoi={cov.coverage?.waiting_for_eoi}
            waitingForDocRequest={cov.coverage?.waiting_for_doc_requests}
            // canEdit={cov.coverage ? cov.plans?.length > 0 : false}
            currentCategory="benefits"
          />
        ))}
      </div>
    );
  } else {
    return <></>;
  }
};
// written with ai assistance
